import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {
    getConcluidosPorData,
    getMetasPeriodo
} from "../../../actions/i4Actions";
import MetasMensalView from "./MetasMensalView";
import {getTempoEtapas} from "../../../actions/orderActions";
import {getSOTiresStatistics} from "../../../actions/serviceOrderStatistics";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'

    },

    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const today = new Date();

const PainelTVMetasMes = ( props ) => {
    const classes = useStyles();
    const periodMin = useSelector( state => state.filter.periodMin );
    const periodMax = useSelector( state => state.filter.periodMax );
    const dispatch = useDispatch();

    const uId =  useSelector(state => state.auth.userId);
    const demo = uId === 268;

    const refreshData = () => {

        if (!demo) {
            dispatch(getConcluidosPorData());
            dispatch(getMetasPeriodo());
            dispatch(getTempoEtapas());

        }

        const dtIniIni = periodMin.substr(0,10) === (new Date(today.getFullYear(), today.getMonth(), 1)).toISOString().substr(0,10);
        const dtFimHoje = periodMax.substr(0,10) === (new Date().toISOString().substr(0,10));

        if (dtIniIni && dtFimHoje) {
            props.setTitulo("PRODUTIVIDADE NO MÊS")
        } else{
            props.setTitulo("PRODUTIVIDADE")
        }
    }



    useEffect( () => {
        refreshData()
    }, [props.contador]);

    useEffect( () => {
        refreshData()
    }, [props.tcContador]);

    return (
        <React.Fragment>
                <MetasMensalView/>
        </React.Fragment>
    )

}
export default (PainelTVMetasMes);


